export default {
  systemName: 'General Login Platform',
  title: {
    login: ' login',
    account: 'Account Or Email',
    phone: 'Phone Number',
    smsCode: 'Verification Code',
    password: 'Password',
  },
  msg: {
    account: 'Please Enter Account Or Email',
    password: 'Please Enter Password',
    passwordRequired: 'Please enter password',
    phoneRequired: 'Please enter phone number',
    phoneInvalid: 'Invalid phone number',
    phoneLengthInvalid: 'Phone number must be 5-15 digits',
    smsCodeRequired: 'Please enter verification code',
    smsCodeInvalid: 'Invalid verification code',
    sendCodeFailed: 'Failed to send code, please retry',
    sendCodeSuccess: 'Code sent successfully',
    loginFailed: 'Login failed, please retry',
  },
  btn: {
    login: 'Sign In',
    sendCode: 'Get Code',
    resend: 's to resend',
  },
};
